import { APP_CONFIG } from '@src/core';
import { YaConfig } from 'angular8-yandex-maps';

export const YA_MAP_CONFIG: YaConfig = {
  apikey: APP_CONFIG.yaMapAPIKey,
  lang: 'ru_RU',
};
